const DateFormatter = (date) => {
    const dateObj = new Date(date);
    // let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    let tz = "UTC"
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      month: 'short',
      day: 'numeric',
      year: 'numeric' 
    });
    let formattedDate;
    try {
      formattedDate = formatter.format(dateObj);
    } catch (error) {
      console.error(error)
      formattedDate = 'error'
    }
  
    return formattedDate;
  };

const DateTimeFormatter = (datetime) => {
  const dateObj = new Date(datetime);
  let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false

  });
  let formattedDate;
  try {
    formattedDate = formatter.format(dateObj);
  } catch (error) {
    console.error(error)
    formattedDate = 'error'
  }

  return formattedDate;
};

const DateAdder = (datetime, days) => {
  const dateObj = new Date(datetime);
  dateObj.setDate(dateObj.getDate() + days)
  let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    month: 'short',
    day: 'numeric',
    year: 'numeric'

  });
  const formattedDate = formatter.format(dateObj);

  return formattedDate;
};

const DateToApi = (date) => {
  const dateObj = new Date(date).toISOString();
  return dateObj;
};

const DateTimeToApi = (datetime) => {
const dateObj = new Date(datetime).toISOString();
return dateObj;
};

const getDateDifference = (startDate, endDate) => {
  // Convert to Date objects
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Calculate the difference in milliseconds
  const diffInMs = end - start;
  
  // Convert milliseconds to days
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  
  // Get weeks and remaining days
  const weeks = Math.floor(diffInDays / 7);
  const days = diffInDays;

  // console.log('getDateDifference', startDate, endDate, weeks, days)

  return { weeks, days };
}


export {DateFormatter, DateTimeFormatter, DateAdder, DateToApi, DateTimeToApi, getDateDifference};